
define('ldsh!modules/editor/templates/controls/resize_bottom', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="handle br" id="lpg-se"></div>\n<div class="handle bc" id="lpg-s"></div>\n<div class="handle bl" id="lpg-sw"></div>';

}
return __p
};});

